/**
 * 获取图片上的像素颜色列表，权重由高到低排序
 * @author Kody
 */
import { getImageData, getCounts, IgnoreFnc } from './helpers';

interface IOpts {
    ignore?: string[] | IgnoreFnc; // 忽略的颜色， rgb(0,0,0)
    scale?: number; // 0 = 高性能低保真， 1=高保真低性能
    skipTransparentPixels?: boolean; // 忽略透明
    success(colors: Array<{ color: string; count: number }>): void; // 权重由高到低排序的颜色 list
    fail?(error: unknown): void;
}

export const RGBaster = async (src: string | HTMLImageElement, opts: IOpts) => {
    const { ignore = [] } = opts;
    let { scale = 0.5 } = opts;
    if (scale > 1) {
        scale = 1;
    }
    if (scale <= 0) {
        scale = 0.1;
    }

    let data = null;
    try {
        data = await getImageData(src, scale);
        opts.success(getCounts(data, ignore));
    } catch (error) {
        if (opts.fail) {
            opts.fail(error);
        }
    }
};

export const rgbToHsl = ($r: number, $g: number, $b: number) => {
    const r = $r / 255;
    const g = $g / 255;
    const b = $b / 255;

    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    let h = 0;
    let s = 0;
    let l = (min + max) / 2;
    const difference = max - min;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        s = l > 0.5 ? difference / (2 - max - min) : difference / (max + min);
        switch (max) {
            case r:
                h = (g - b) / difference + (g < b ? 6 : 0);
                break;
            case g:
                h = 2.0 + (b - r) / difference;
                break;
            case b:
                h = 4.0 + (r - g) / difference;
                break;
        }
        h = Math.round(h * 60);
    }
    s = Math.round(s * 100);
    l = Math.round(l * 100);
    return [h, s, l];
};

export const hslToRgb = ($h: number, $s: number, $l: number) => {
  const s = $s / 100;
  const l = $l / 100;
  const k = (n: number) => (n + $h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => {
      return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  }
  return [Math.round(255 * f(0)), Math.round(255 * f(8)), Math.round(255 * f(4))];
}
